import parametrizacao from './parametrizacao'
import gerenciamentoEnvio from './gerenciamentoEnvio'

export default [
    ...parametrizacao,
    ...gerenciamentoEnvio,
]